export enum MewsTeam {
    Accounting = 'Accounting',
    Accounts = 'Accounts',
    ActivationExperience = 'ActivationExperience',
    Analytics = 'Analytics',
    Billing = 'Billing',
    Connectivity = 'Connectivity',
    Distribution = 'Distribution',
    EcosystemExperience = 'EcosystemExperience',
    Expansion = 'Expansion',
    FinancialServices = 'FinancialServices',
    GroupsEvents = 'GroupsEvents',
    GuestExperience = 'GuestExperience',
    Infrastructure = 'Infrastructure',
    Jarvis = 'Jarvis',
    Multicurrency = 'Multicurrency',
    PaymentExperience = 'PaymentExperience',
    PaymentPayout = 'PaymentPayout',
    PaymentProcessing = 'PaymentProcessing',
    Pricing = 'Pricing',
    Productivity = 'Productivity',
    Reservations = 'Reservations',
    Services = 'Services',
    Spacetime = 'Spacetime',
    Tooling = 'Tooling',
    Users = 'Users',
}
